import { QuickLink } from './quick-link';

export class QuickLinks {

    genericQuickLinks: Array<QuickLink>;
    eSquirrelQuickLinks: Array<QuickLink>;
    gmtQuickLinks: Array<QuickLink>;
    hsmQuickLinks: Array<QuickLink>;
    digiFitQuicklinks: Array<QuickLink>;

    constructor() {
        this.genericQuickLinks = [];
        this.eSquirrelQuickLinks = [];
        this.gmtQuickLinks = [];
        this.hsmQuickLinks = [];
        this.digiFitQuicklinks = [];
    }

    /**
     * Returns true if the object contains at least one quicklink.
     * @returns {boolean}
     */
    hasQuickLinks(): boolean {
        return (this.genericQuickLinks.length +
            this.eSquirrelQuickLinks.length +
            this.digiFitQuicklinks.length +
            this.gmtQuickLinks.length +
            this.hsmQuickLinks.length) > 0;
    }

    /**
     * Returns joined arrays of all quicklinks
     * @returns {Array<QuickLink>}
     */
    all(): Array<QuickLink> {
        return [
            ...this.genericQuickLinks,
            ...this.eSquirrelQuickLinks,
            ...this.gmtQuickLinks,
            ...this.hsmQuickLinks,
            ...this.digiFitQuicklinks
        ];
    }

}
